import React, { FC, useState } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import moment from 'moment';
// import ContainerWithShadow from 'components/common/ContainerWithShadow';
import Calendar from 'components/common/calendar/index';
import LineChart from 'components/common/lineChart/lineChart';
import calendarStyles from 'components/common/calendar/index.module.scss';
import { useHistory } from 'react-router-dom';
import { logEvent } from 'services/amplitude';
import ShareAnetaPack from 'components/common/shareAnetaPack';
import { LineChartTypes } from 'types';
import buttons from 'style/buttons.module.scss';
import moduleStyles from './styles.module.scss';

interface TimeTableProps {
  kidName: string;
  role?: string;
}
const TimeTable: FC<TimeTableProps> = ({ kidName, role }) => {
  const [selectedDate, setSelectedDate] = useState(moment().toDate());
  const searcIndex = (inputArray: moment.Moment[][], searchValue: string) => {
    const arrayString: string[][] =
      (!_.isEmpty(inputArray) &&
        inputArray.map((w: moment.Moment[]) => {
          const toString = w.map((day: moment.Moment) => {
            return moment(day).format('YYYY-MM-DD');
          });
          return toString;
        })) ||
      [];

    for (let i = 0, l = inputArray.length; i < l; i += 1) {
      const j = arrayString[i].indexOf(searchValue);
      if (j >= 0) {
        return [i, j];
      }
    }
    return null;
  };

  const history = useHistory();
  const backUrl =
    role === 'teacher'
      ? '/onboarding/profile'
      : '/onboarding/choose-map/switch-template';

  return (
    <div className={`${moduleStyles.removePadding}`}>
      <div
        className={classNames(
          calendarStyles.container,
          calendarStyles.flex,
          moduleStyles.contentContainer
        )}
      >
        <Calendar
          setSelectedDate={setSelectedDate}
          searcIndex={searcIndex}
          kidName={kidName}
        />
        <div className={moduleStyles.rightSideBlock}>
          <ShareAnetaPack searcIndex={searcIndex} />
          <LineChart
            selectedDate={selectedDate}
            type={LineChartTypes.OnlineOfflineComparison}
            styles={{
              boxShadow: '0 10px 40px rgba(182, 198, 214, 0.2)',
              width: 288,
              padding: 16,
            }}
          />
        </div>
      </div>
      <div className={moduleStyles.buttons}>
        <button
          onClick={() => history.push(backUrl)}
          className={buttons.buttonOutline}
          type="button"
        >
          Back
        </button>
        <button
          type="submit"
          className={buttons.buttomPrimary}
          onClick={() => {
            history.push('/onboarding/timetable/resources');
            logEvent('TimeTableNext');
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default TimeTable;
